import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TabBarBaseComponent } from '@luggagehero/features/ui';
@Component({
  selector: 'lh-tab-bar',
  templateUrl: 'tab-bar.component.html',
  styleUrls: ['tab-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TabBarComponent extends TabBarBaseComponent {}
